<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<crucible-dialog
  dialogTitle="Add team by unit"
  [hideDefaultActions]="true"
  [guardUnsavedWork]="true"
>
@if (!!data && !!data.unitList) {
  <div crucibleDialogContent>
    <div class="all-content">
      <mat-form-field class="search-control">
        <mat-label>Search</mat-label>
        <input
          matInput
          [(ngModel)]="filterString"
          (ngModelChange)="applyFilter($event)"
          placeholder="Search"
          />
        @if (filterString) {
        <button mat-icon-button matSuffix (click)="applyFilter('')" title="Clear Search">
          <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
        </button>
        }
      </mat-form-field>
      <div class="unit-list-div">
        @for (unit of filteredList(); track unit) {
          <div class="unit-div">
            <button mat-stroked-button class="unit-button" (click)="handleEditComplete(unit.id)">
              {{ unit.shortName }} - {{ unit.name }}
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}
<ng-container crucibleDialogActions>
  <button matButton="outlined" type="button" (click)="handleEditComplete(null)">
    Cancel
  </button>
</ng-container>
</crucible-dialog>
